<template>
  <svg @click="$emit('back')" :style="style" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="&#229;&#175;&#188;&#232;&#136;&#170;&#230;&#160;&#143;/&#229;&#155;&#190;&#230;&#160;&#135;"
      clip-path="url(#clip0_3327_70312)">
      <path id="Vector 39" d="M21 12H19M3 12L9.5 6.5M3 12L9.5 17.5M3 12H15.5" :stroke="color" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3327_70312">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'icon-back',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor:'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>